var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.community'] = (function () {
    'use strict';

    const CONFIG = {
        IMAGE1_SELECTOR: '.block-community__image--1',
        IMAGE1_ANIMATION: 'animate__fadeInRight',
        IMAGE2_SELECTOR: '.block-community__image--2',
        IMAGE2_ANIMATION: 'animate__fadeInUp',
        FEATURE_SELECTOR: '.block-community__feature',
        FEATURE_ANIMATION: 'animate__zoomIn',
        FEATURE_STAGGER: 150
    };

    const initialize = (block) => {
        if (!block || !block.id) return;

        const targets = [];

        if (block.querySelectorAll(CONFIG.IMAGE1_SELECTOR).length > 0) {
            targets.push({ selector: CONFIG.IMAGE1_SELECTOR, type: CONFIG.IMAGE1_ANIMATION, stagger: 0 });
        }
        if (block.querySelectorAll(CONFIG.IMAGE2_SELECTOR).length > 0) {
            targets.push({ selector: CONFIG.IMAGE2_SELECTOR, type: CONFIG.IMAGE2_ANIMATION, stagger: 0 });
        }
        if (block.querySelectorAll(CONFIG.FEATURE_SELECTOR).length > 0) {
            targets.push({ selector: CONFIG.FEATURE_SELECTOR, type: CONFIG.FEATURE_ANIMATION, stagger: CONFIG.FEATURE_STAGGER });
        }

        if (targets.length === 0) return;

        App.ZagScrollAnimate.initialize(`#${CSS.escape(block.id)}`, {
            targets,
            overflow: true
        });
    };

    return {
        initialize
    };

})();
